module.exports = __webpack_public_path__ + "static/queenie-07ae551355cc1846db499d60244e9500.jpg";